import dayjs, { Dayjs } from 'dayjs'
import {
  RosteredShift,
  transformRosteredShiftOnGet,
  transformRosteredShiftOnSave,
} from './rosteredShift'
import { Nullable } from '../types'

export interface Roster {
  id: string
  rosteredShifts: RosteredShift[]
  startDateTime: Dayjs
  endDateTime: Dayjs
  datestampDeleted: Nullable<Dayjs>
  datestampPublished: Nullable<Dayjs>
  datestampLocked: Nullable<Dayjs>
  datestampModified: Nullable<Dayjs>
  datestampCreated: Nullable<Dayjs>
  totalHours: Nullable<number>
}

// Functions to apply transformations to Roster object
export const transformRosterOnGet = (roster: Roster): Roster => {
  return {
    ...roster,
    startDateTime: dayjs(roster.startDateTime),
    endDateTime: dayjs(roster.endDateTime),
    datestampDeleted: roster.datestampDeleted
      ? dayjs(roster.datestampDeleted)
      : null,
    datestampPublished: roster.datestampPublished
      ? dayjs(roster.datestampPublished)
      : null,
    datestampLocked: roster.datestampLocked
      ? dayjs(roster.datestampLocked)
      : null,
    datestampModified: roster.datestampModified
      ? dayjs(roster.datestampModified)
      : null,
    rosteredShifts: roster.rosteredShifts
      ? roster.rosteredShifts.map(transformRosteredShiftOnGet)
      : [],
    datestampCreated: roster.datestampCreated
      ? dayjs(roster.datestampCreated)
      : null,
    totalHours: roster.totalHours ?? 0,
  }
}

export const transformRosterOnSave = (roster: Roster): object => {
  return {
    ...roster,
    startDateTime: roster.startDateTime.utc(),
    endDateTime: dayjs(roster.endDateTime).utc(),
    datestampDeleted: roster.datestampDeleted
      ? dayjs(roster.datestampDeleted).utc()
      : null,
    datestampPublished: roster.datestampPublished
      ? dayjs(roster.datestampPublished).utc()
      : null,
    datestampLocked: roster.datestampLocked
      ? dayjs(roster.datestampLocked).utc()
      : null,
    datestampModified: roster.datestampModified
      ? dayjs(roster.datestampModified).utc()
      : null,
    rosteredShifts: roster.rosteredShifts.map(transformRosteredShiftOnSave),
    datestampCreated: roster.datestampCreated
      ? dayjs(roster.datestampCreated).utc()
      : null,
  }
}
